export const contributorPermissionLookup = {
  no_access: "No access",
  view: "Viewer",
  admin: "Editor"
}
